<template>
  <div class="toolbar-block pt-2">
    <v-btn depressed class="mx-1" fab small id="delete-shape-btn">
      <v-icon>mdi-delete</v-icon>
    </v-btn>
    <v-btn depressed class="mx-1" fab small id="cut-shape-btn">
      <v-icon>mdi-content-cut</v-icon>
    </v-btn>
    <v-btn depressed class="mx-1" fab small id="copy-shape-btn">
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
    <v-btn depressed class="mx-1" fab small id="paste-shape-btn">
      <v-icon>mdi-content-paste</v-icon>
    </v-btn>
    <v-btn depressed class="mx-1" fab small id="undo-shape-btn">
      <v-icon>mdi-undo</v-icon>
    </v-btn>
    <v-btn depressed class="mx-1" fab small id="redo-shape-btn">
      <v-icon>mdi-redo</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.toolbar-block {
  background-color: #eee;
}
</style>
